<template>
  <div v-if="bodyShow" class="ms-report-list">
    <div class="report-list"  v-for="(item,index) in my_report" :key="index">
      <img class="cp-img" :src="item.image"  />
      <div class="right-text">
        <h3 class="name text-ellipsis">{{item.name}}</h3>
        <h4 class="text-ellipsis">完成时间：{{item.ctime}}</h4>
        <h4 class="text-ellipsis">
          <span class="text-ellipsis">订单编号：{{item.wxnum}}</span>
          <a class="copy" v-clipboard:copy="item.wxnum" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</a>
        </h4>
        <h3 @click="$router.push(msReportHandle(item.link)+'?evaluation_id='+item.evaluation_id)" class="orange">查看报告<img src="@a/ms_system/my-right.png" alt=""></h3>
      </div>
    </div>
  </div>
</template>

<script>
import { my } from "@/api/measurement_system";
export default {
  data() {
    return {
      bodyShow:false,
      data:{},
      my_report:[]
    }
  },
  methods: {
    // 判断是否是测评报告页面
    msReportHandle(link){
      let str = link.indexOf('_report');
      return str>-1?link:`${link}_report`
    },
    // 复制成功
    onCopy(e) {
      this.$toast('复制成功!');
    },
    // 复制失败
    onError(e) {
      alert("失败");
    },
    /*
     *@Description: 初始化请求数据
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-11 18:08:59
     */
    pullData() {
      // loading
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      my({
        show_old_report:1
      }).then(data => {
        this.data = data;
        this.my_report = data.my_report;
        this.bodyShow = true;
        this.$toast.clear();
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss">
.ms-report-list {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffff;
  overflow: auto;
  .report-list{
    display: flex;
    padding: 30px;
    box-sizing: border-box;
    border-bottom: 1px solid #cccccc;
    &:last-child{
      border-bottom: 0;
    }
    .cp-img{
      width: 200px;
      height: 150px;
      margin-right: 20px;
    }
    .right-text{
      flex: 1;
      h3{
        font-size: 30px;
        color: #252525;
        line-height: 1;
        max-width: 470px;
        margin-bottom: 12px;
      }
      h3.name{
        font-weight: bold;
      }
      h3.orange{
        color: #EB5032;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        img{
          width: 14px;
          height: 24px;
          margin-left: 6px;
        }
      }
      h4{
        font-size: 24px;
        color: #666666;
        line-height: 1;
        display: block;
        align-items: center;
        margin-bottom: 12px;
        width: 470px;
        span{
          display: inline-block;
          vertical-align: middle;
          width: 400px;
          margin-right: 10px;
        }
        .copy{
          display: inline-block;
          text-align: center;
          width: 60px;
          line-height: 32px;
          height: 32px;
          font-size: 20px;
          color: #666666;
          margin-left: auto;
          border:1px solid #cccccc;
          border-radius:4px;
          box-sizing: border-box;
        }
      }
    }
    
  }
}
</style>